
<template>
  <div>
    <!-- Comprobante: reemplaza al formulario al terminar. Antes solo salia
         un aviso flotante que desaparecia solo y el modal se cerraba, asi
         que no quedaba nada del numero de separacion. -->
    <div v-if="comprobante" class="text-center py-2">
      <feather-icon icon="CheckCircleIcon" size="48" class="text-success mb-1" />
      <h3 class="mb-50">¡Separación realizada!</h3>
      <p class="text-muted mb-2">
        Guarda este número. Preséntalo en la farmacia para reclamar tu medicamento.
      </p>

      <div class="border rounded p-2 mb-2 mx-auto" style="max-width: 320px; background-color: rgba(115,103,240,0.06);">
        <small class="text-muted d-block">Número de separación</small>
        <div class="font-weight-bolder text-primary" style="font-size: 2rem; letter-spacing: 2px;">
          {{ comprobante.id }}
        </div>
      </div>

      <div class="text-left mx-auto mb-2" style="max-width: 320px;">
        <div v-if="comprobante.medicamento" class="mb-50">
          <small class="text-muted d-block">Medicamento</small>
          <span class="font-weight-bold">{{ comprobante.medicamento }}</span>
        </div>
        <div v-if="comprobante.cantidad" class="mb-50">
          <small class="text-muted d-block">Cantidad separada</small>
          <span class="font-weight-bold">{{ comprobante.cantidad }}</span>
        </div>
        <div>
          <small class="text-muted d-block">Fecha</small>
          <span class="font-weight-bold">{{ comprobante.fecha }}</span>
        </div>
      </div>

      <b-alert variant="warning" show class="p-1 text-left mx-auto" style="max-width: 320px;">
        <small>
          <feather-icon icon="CameraIcon" size="14" class="mr-25" />
          Toma una captura de pantalla de este número antes de cerrar.
        </small>
      </b-alert>

      <b-button variant="primary" class="mt-1" @click="cerrarComprobante">
        Entendido
      </b-button>
    </div>

    <!-- Se consulta la disponibilidad al abrir: si la farmacia esta cerrada o
         no ha publicado horarios se dice de una vez, en lugar de dejar que la
         persona llene documento, nombre, telefono y cantidad para enterarse
         al enviar. -->
    <div v-else-if="verificando" class="text-center py-3 text-muted">
      <b-spinner small class="mr-50" />
      <span>Verificando disponibilidad de la farmacia...</span>
    </div>

    <div v-else-if="noDisponible" class="text-center py-2">
      <feather-icon icon="ClockIcon" size="44" class="mb-1" style="color:#ff9f43;" />
      <h4 class="mb-1">Por ahora no puedes separar aquí</h4>
      <div class="text-left mx-auto p-1 rounded" style="max-width:360px;font-size:0.9rem;line-height:1.5;
                  background-color:rgba(255,159,67,0.12);border-left:3px solid #ff9f43;">
        {{ noDisponible }}
      </div>
      <b-button variant="outline-secondary" class="mt-2" @click="$emit('cerrarModalNotificacion')">
        Cerrar
      </b-button>
    </div>

    <div v-else>
    <h2>Separar medicamentos</h2>

    <!-- Respaldo: si el estado cambia entre que se abrio el formulario y se
         envio, el servidor sigue siendo la autoridad. -->
    <div v-if="errors['date']" class="d-flex align-items-start p-1 mt-1 mb-1 rounded"
         style="background-color: rgba(255,159,67,0.12); border-left: 3px solid #ff9f43;">
      <feather-icon icon="ClockIcon" size="20" class="mr-1 mt-25 flex-shrink-0" style="color:#ff9f43;" />
      <div style="font-size: 0.9rem; line-height: 1.45;">{{ errors["date"][0] }}</div>
    </div>
    <b-form-group label="Tipo Documento:" label-for="input-3">
      <v-select
        v-model="separe.documentType"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :clearable="false"
        label="description"
        placeholder="-- Por favor seleccione una opcion --"
        :options="documentsType"
        :reduce="(option) => option.id"
      />
      <small v-if="errors['documentType']" class="text-danger">{{
        errors["documentType"][0]
      }}</small>
    </b-form-group>
    <b-form-group id="input-group-2" label="Documento" label-for="input-2">
      <b-form-input
        id="input-2"
        v-model="separe.document"
        placeholder="Documento"
        required
      ></b-form-input>
      <small v-if="errors['document']" class="text-danger">{{
        errors["document"][0]
      }}</small>
    </b-form-group>
    <b-form-group id="input-group-2" label="Nombre" label-for="input-2">
      <b-form-input
        id="input-2"
        v-model="separe.name_client"
        placeholder="Nombre"
        required
      ></b-form-input>
      <small v-if="errors['name_client']" class="text-danger">{{
        errors["name_client"][0]
      }}</small>
    </b-form-group>

    <b-form-group id="input-group-2" label="Apellidos" label-for="input-2">
      <b-form-input
        id="input-2"
        v-model="separe.surnames"
        placeholder="Apellido"
        required
      ></b-form-input>
      <small v-if="errors['surnames']" class="text-danger">{{
        errors["surnames"][0]
      }}</small>
    </b-form-group>

    <b-form-group id="input-group-2" label-for="input-2">
      <template #label>
        Cantidad
        <!-- El maximo se conoce desde antes de escribir: mejor decirlo que
             rechazar el formulario despues. -->
        <small v-if="maxUnidades" class="text-muted font-weight-normal">
          (máximo {{ maxUnidades }} por solicitud)
        </small>
      </template>
      <b-form-input
        id="input-2"
        v-model="separe.quantity_reserve"
        :placeholder="maxUnidades ? `Hasta ${maxUnidades}` : 'Cantidad'"
        required
      ></b-form-input>
      <small v-if="errors['quantity_reserve']" class="text-danger">{{
        errors["quantity_reserve"][0]
      }}</small>
    </b-form-group>

    <b-form-group
      id="input-group-2"
      label="Teléfono"
      label-for="input-2"
    >
      <b-form-input
        id="input-2"
        v-model="separe.phone"
        placeholder="telefono"
        required
      ></b-form-input>
      <small v-if="errors['phone']" class="text-danger">{{
        errors["phone"][0]
      }}</small>
    </b-form-group>
    <b-form-checkbox
      id="checkbox-1"
      v-model="separe.processingPersonalData"
      name="checkbox-1"
      unchecked-value="not_accepted"
    >
        Acepto los
        <a href="https://indiju.com.co/index.php/terminos-y-condiciones/" target="_blank">terminos y condiciones</a>
        y la
        <a href="https://indiju.com.co/index.php/politica-de-privacidad/" target="_blank">politica de privacidad</a>
    </b-form-checkbox>
    <small v-if="errors['processingPersonalData']" class="text-danger">{{
      errors["processingPersonalData"][0]
    }}</small>

    <b-button
      class="btn-sm mt-1"
      block
      :disabled="isSubmitting"
      @click="enviarSepare"
    >
      <b-spinner small v-if="isSubmitting" />
      {{ isSubmitting ? "Separando..." : "Separar medicamento" }}
    </b-button>
    </div>
  </div>
</template>
<script>
import {
  BFormGroup,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormInput,
  BButton,
  BFormRadioGroup,
  BFormSelect,
  BFormSelectOption,
  BSpinner,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
export default {
  props: {
    search: {
      type: Object,
    },
    cumDetail: {
      type: Object,
    },
  },
  components: {
    BFormGroup,
    BFormCheckbox,
    BFormCheckboxGroup,
    BFormInput,
    BButton,
    BFormRadioGroup,
    BFormSelect,
    BFormSelectOption,
    BSpinner,
    vSelect,
  },
  data() {
    return {
      isSubmitting: false,
      comprobante: null,
      verificando: true,
      noDisponible: null,
      maxUnidades: null,
      separe: {
        documentType: "",
        processingPersonalData: false,
        date:true
      },
      errors: [],
      documentsType: [],
    };
  },
  methods: {

    getDocuments() {
      this.$http.get(`/documenttypes`, { params: { scope: 'natural', perPage: 50 } }).then((res) => {
        this.documentsType = res.data.document_types;
      });
    },
    enviarSepare() {
      if (this.isSubmitting) {
        return;
      }
      let notificationRequest = Object.assign(this.separe, this.cumDetail);
      const _this = this;
      this.errors = [];
      this.isSubmitting = true;
      this.$http
        .post(`/cum/separe`,notificationRequest)
        .then((res) => {
          // Se muestra un comprobante en pantalla en vez de cerrar el modal:
          // el numero de separacion tiene que quedar visible para poder
          // fotografiarlo y presentarlo en la farmacia.
          _this.comprobante = {
            id: res.data.id,
            medicamento: _this.cumDetail?.description || _this.cumDetail?.name || null,
            cantidad: _this.separe.quantity_reserve || null,
            fecha: new Date().toLocaleString("es-CO"),
          };
        })
        .catch(function (error) {
          _this.errors = error.response.data.errors;
        })
        .finally(() => {
          _this.isSubmitting = false;
        });
    },

    cerrarComprobante() {
      this.comprobante = null;
      this.$emit("cerrarModalNotificacion");
    },

    verificarDisponibilidad() {
      const farmacia = this.cumDetail?.customer_id;

      // Sin farmacia identificada no se puede consultar: se deja pasar y el
      // servidor validara al enviar, que es la autoridad final.
      if (!farmacia) {
        this.verificando = false;
        return;
      }

      this.$http
        .get(`/cum/separe/disponibilidad/${farmacia}`)
        .then(({ data }) => {
          if (!data.available) {
            this.noDisponible = data.message;
          }
          this.maxUnidades = data.max_units;
        })
        .catch(() => {
          // Si la consulta falla no se bloquea a nadie: se muestra el
          // formulario y el servidor decidira al enviar.
        })
        .finally(() => {
          this.verificando = false;
        });
    },
  },
  created() {
    this.getDocuments();
    this.verificarDisponibilidad();
  },
};
</script>
